import React, { useState } from 'react';
import { Box, Container } from '@hover/blueprint';
import { useInterSectionObserver } from '../../../hooks';
import Desktop from './Desktop';
import { OUR_VALUES } from '../../../constants';
import Mobile from './Mobile';

interface Props {
  setCurrentSection: React.Dispatch<React.SetStateAction<string>>;
}

const CareersOurValues: React.FC<Props> = ({ setCurrentSection }) => {
  const [currentTab, setCurrentTab] = useState<string>(OUR_VALUES[0].title);
  const selectTab = (title: string) => setCurrentTab(title);

  const currentDescription = OUR_VALUES.find(
    value => value.title === currentTab,
  )?.description;

  const ourValuesRef = useInterSectionObserver(
    isIntersecting => {
      if (isIntersecting) {
        setCurrentSection('Our Values');
      }
    },
    {
      rootMargin: '0px',
      threshold: 0.1,
      root: null,
    },
  );
  return (
    <Box
      w="100%"
      bg="brandNavy.100"
      justifyContent="center"
      ref={ourValuesRef.elementRef}
      position={{ desktop: 'relative' }}
    >
      <Box
        id="careers-our-values"
        position={{ desktop: 'absolute' }}
        display={{ base: 'none', desktop: 'block' }}
        w={0}
        h={0}
        top="70px"
      />
      <Container
        maxW="8xl"
        pl={{ base: 500, tablet: '56px', desktop: '220px' }}
        pr={{ base: 500, tablet: '56px' }}
        py={{ base: 700, tablet: 1000 }}
      >
        <Desktop
          selectTab={selectTab}
          currentTab={currentTab}
          description={currentDescription ?? ''}
        />
        <Mobile
          selectTab={selectTab}
          currentTab={currentTab}
          description={currentDescription ?? ''}
        />
      </Container>
    </Box>
  );
};

export default CareersOurValues;
